/**
 * DO NOT USE. This helper function is only here to map historical events.
 */
export const getCohortByPortalZone = (zone) => {
    const cohortToZoneMap = {
        csr: 'csr',
        delegate: 'estimator',
        estimator: 'estimator',
        'external-estimator': 'estimator',
        sms: 'estimator',
        tplap: 'insured',
    };
    return cohortToZoneMap[zone];
};
export const getCanonPortalZone = (zone) => {
    const deprecatedToCanonZoneMap = {
        'external-estimator': 'delegate',
        estimator: 'delegate',
    };
    return deprecatedToCanonZoneMap[zone];
};
